import { VueComponent } from '../../../shared/types/VueComponent'
import { AvailableButtonsTypes } from '../../NewMessageEditors/NewMessageEditorWithMedia/ButtonsConstructor/logic/types'
import { CustomMediaTypes } from '../../NewMessageEditors/NewMessageEditorWithMedia/types'

export enum DistributionEditorAction {
  new = 'new',
  watch = 'watch',
  copy = 'copy',
  edit = 'edit'
}

export type MessageEditorProps = {
  defaultMessageEditorButtons: AvailableButtonsTypes
  board_key: string
  editorButtonsHelpView: VueComponent
  customMediaTypes?: CustomMediaTypes
}

export type UtmSource = {
  id: number
  value: string
}

export enum ConditionType {
  Sent = 'sent',
  Activity = 'activity',
  Utm = 'utm',
  Labels = 'labels',
  Users = 'users',
  Boosts = 'boosts',
}

export enum ConditionMode {
  Include = 'Include',
  Exclude = 'Exclude',
  Less = 'Less',
  Greater = 'Greater'
}

export enum BoostsConditionModeEnum {
  Equals = 'Equals',
  Less = 'Less',
  Greater = 'Greater'
}

export enum DistributionState {
  Wait,
  Start,
  Success,
  Error,
  Cancel
}
